<template>
  <!-- <div style="flex: 1;"> -->
  <div
    class="owal event banner timeline container"
  >
    <div
      :title="fullFormattedDate"
      class="owal event banner timeline date"
    >
      {{ formattedDate }}
    </div>
    <div
      class="owal event banner timeline line"
    >
      <div
        class="owal event banner timeline dot"
        :style="backgroundColor"
      />
    </div>
  </div>
<!-- </div> -->
</template>

<script>
import moment from 'moment'

export default {
  name: 'OwalEventBannerTimeline',
  props: {
    /**
     * The date of the event, represented as a number of seconds since the Unix epoch date.
     * You can obtain this from any date object by calling `valueOf()` on it.
     *
     * @default unixEpochMilliseconds The offset of the current date.
     */
    unixEpochMilliseconds: {
      type: Number,
    },
    /**
     * You can pass in the background color for the timeline dot, or use the default gray
     */
    dotColor: {
      type: String,
      default: '#9B9B9B',
    },
  },
  computed: {
    fullFormattedDate () {
      if (!this.unixEpochMilliseconds) {
        return undefined
      }
      const formattedDate = moment(this.unixEpochMilliseconds).format(
        'MMMM DD, YYYY @ h:mm a',
      )
      // console.log(`Format for unix ${this.unixEpochMilliseconds}: ${formattedDate}`)
      return formattedDate
    },
    formattedDate () {
      if (!this.unixEpochMilliseconds) {
        return undefined
      }
      const formattedDate = moment(this.unixEpochMilliseconds).format(
        'h:mm:ss a',
      )
      // console.log(`Format for unix ${this.unixEpochMilliseconds}: ${formattedDate}`)
      return formattedDate
    },
    backgroundColor () {
      return `background: ${this.dotColor}`
    },
  },
}
</script>

<style scoped>
.owal.event.banner.timeline.container {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-content: center;
  justify-content: flex-end;
  /* We might not need this, commenting out to prevent mixing up with other CSS  */
  /* flex-grow: 0; */
  flex-shrink: 2;
  flex-basis: auto;
  border: none;
  background: none;
  margin: 0;
  box-shadow: none;
  padding: 0;
  max-width: 8.24rem;
  height: 100%;
}

.owal.event.banner.timeline.date {
  height: 100%;
  flex-grow: 1;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  align-content: center;
  opacity: 0.8;
  font-family: 'Lato-Regular';
  font-size: 1.0833rem;
  color: #324057;
  letter-spacing: 0;
  cursor: pointer;
  min-width: 5.51rem;
}

.owal.event.banner.timeline.line {
  height: 100%;
  width: 0.07142857143rem; /* Equal to 1 pixel, at 14px based rems. */
  margin: 0 0.7857142857rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  align-content: center;
  justify-content: center;
  flex-grow: 0;
  flex-shrink: 0;
  background: #475669;
  overflow: visible;
}

.owal.event.banner.timeline.dot {
  height: 1.14rem;
  width: 1.14rem;
  border-radius: 0.6rem;
  border: 1px solid #475669;
}
</style>
